import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const StoryOverviewPage = lazy(
  () =>
    import('./StoryOverviewPage.eager').then(mod => ({
      default: mod.StoryOverviewPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
